import * as React from "react";
import type { SVGProps } from "react";
const SvgWc = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21 11.5A2.5 2.5 0 0 0 18.5 9H10V2c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v8.5c0 1.76 1.31 3.2 3 3.45V22c0 .55.45 1 1 1h12c.34 0 .65-.17.84-.46s.21-.64.08-.95l-1.73-3.9a6.9 6.9 0 0 0 1.79-4.18c.62-.46 1.03-1.18 1.03-2.01zM13 18c-2.41 0-4.43-1.72-4.9-4h9.8a5 5 0 0 1-4.9 4m5.5-7c.28 0 .5.22.5.5s-.22.5-.5.5H9.65c.15-.31.25-.65.3-1.01.02 0 .03.01.05.01zM5 10.5V3h3v7.5c0 .83-.67 1.5-1.5 1.5S5 11.33 5 10.5M8 21v-3.11a6.97 6.97 0 0 0 8.58 1.12l.89 1.99z"
    />
  </svg>
);
export default SvgWc;
